// Cliente axios dedicado à página pública de convite de responsável.
// Não deve importar `api` de `services/DefaultService`: aquela instância tem
// interceptors (useAxiosInterceptors) que injetam Authorization e, em um 401
// qualquer, disparam logout()/redirect — comportamento incompatível com uma
// página 100% pública, acessada por um responsável sem login/token no app.
import axios from 'axios';
import { toUserMessage } from 'utils/apiErrorHelper';
import type { IPublicInviteInfoProps, IResponsibleInviteSubmitProps } from './types';

export const publicApi = axios.create({
  // @ts-ignore
  baseURL: window._env_.REACT_APP_API_URL_HOST,
  timeout: 100000,
});

const ENDPOINT = 'v1/public/responsible-invites';

const formatApiError = (error: any): Error => {
  return new Error(toUserMessage(error));
};

export const getPublicInviteInfoAsync = async (
  token: string,
): Promise<IPublicInviteInfoProps> => {
  try {
    const response = await publicApi.get(`${ENDPOINT}/${token}`);
    return response.data;
  } catch (error) {
    throw formatApiError(error);
  }
};

export const submitPublicInviteAsync = async (
  token: string,
  data: IResponsibleInviteSubmitProps,
): Promise<void> => {
  const formData = new FormData();
  formData.append('name', data.name);
  formData.append('cpf', data.cpf);
  if (data.phone) formData.append('phone', data.phone);
  formData.append('email', data.email);
  formData.append('file', data.file);

  try {
    await publicApi.post(`${ENDPOINT}/${token}/submit`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  } catch (error) {
    throw formatApiError(error);
  }
};
